import { z } from 'zod';

export const userIdDto = z.string();

export type UserIdDto = z.infer<typeof userIdDto>;
